<template>
  <transition name="fade">
    <div v-if="isLoading" class="fullscreen-loader" :class="{ 'dark-mode': darkMode }">
      <div class="loader-content">
        <!-- 动画部分 - 可以使用任何你喜欢的动画 -->
        <div class="loader-animation">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <p class="loading-text">{{ loadingText }}</p>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = defineProps({
  // 加载文本
  loadingText: {
    type: String,
    default: '正在加载...',
  },
  // 是否使用暗色模式
  darkMode: {
    type: Boolean,
    default: false,
  },
  // 最小显示时间(毫秒)，避免闪烁
  minDisplayTime: {
    type: Number,
    default: 1000,
  },
  // 是否模拟加载(开发时使用)
  simulateLoad: {
    type: Boolean,
    default: false,
  },
  // 模拟加载时间(毫秒)
  simulateTime: {
    type: Number,
    default: 1000,
  },
})

const isLoading = ref(true)

// 加载完成的方法
const finishLoading = () => {
  isLoading.value = false
}

// 模拟加载过程
if (props.simulateLoad) {
  setTimeout(finishLoading, props.simulateTime)
}

// 暴露方法给父组件
defineExpose({
  finishLoading,
})

// 组件挂载后开始检测页面是否加载完成
onMounted(() => {
  if (!props.simulateLoad) {
    // 如果页面已经加载完成
    if (document.readyState === 'complete') {
      setTimeout(finishLoading, props.minDisplayTime)
    } else {
      // 监听页面加载完成事件
      window.addEventListener('load', () => {
        setTimeout(finishLoading, props.minDisplayTime)
      })

      // 设置最大加载时间(10秒超时)
      setTimeout(finishLoading, 10000)
    }
  }
})
</script>

<style scoped>
.fullscreen-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s ease;
}

.fullscreen-loader.dark-mode {
  background: #222222;
  color: #fff;
}

.loader-content {
  text-align: center;
  transform: translateY(-50px);
}

.loader-animation {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.circle {
  width: 15px;
  height: 15px;
  margin: 0 8px;
  background-color: var(--el-color-primary);
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out;
}

.fullscreen-loader.dark-mode .circle {
  background-color: #ffffff;
}

.circle:nth-child(2) {
  animation-delay: 0.2s;
}

.circle:nth-child(3) {
  animation-delay: 0.4s;
}

.loading-text {
  font-size: 18px;
  margin-top: 20px;
  font-weight: 500;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-leave-to {
  opacity: 0;
}
</style>
